import React from 'react';
import { Card, CardContent, Typography, Box, Grid, useTheme } from '@mui/material';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';

const AnalyticsItem = ({ title, icon, data, totalMonthlyAmount, theme, type }) => {
  const isService = type === 'service';
  const mainColor = isService ? theme.palette.primary.main : theme.palette.secondary.main;
  const lightColor = isService ? theme.palette.primary.light : theme.palette.secondary.light;

  if (!data) {
    return (
      <Card sx={{ p: 2, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 3, boxShadow: 3 }}>
        <Typography>No top {type} data for this month.</Typography>
      </Card>
    );
  }

  return (
    <Card sx={{ p: 2, borderRadius: 3, boxShadow: 3, height: '100%', borderTop: `4px solid ${mainColor}` }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Box sx={{ backgroundColor: lightColor, borderRadius: '50%', p: 1, display: 'inline-flex', mr: 1.5 }}>
            {icon}
          </Box>
          <Typography variant="h6" fontWeight="600">{title}</Typography>
        </Box>
        <Typography variant="h5" fontWeight="bold" noWrap color={mainColor} sx={{ my: 1.5 }}>
          {data.serviceName || data.productName}
        </Typography>
        <Grid container spacing={1} sx={{ mt: 1 }}>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary">Usage Count</Typography>
            <Typography fontWeight="600">{data.usageCount}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary">Total Amount</Typography>
            <Typography fontWeight="600">₹{data.totalAmount.toLocaleString('en-IN')}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary">Monthly Total</Typography>
            <Typography fontWeight="600">₹{totalMonthlyAmount.toLocaleString('en-IN')}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary">Contribution</Typography>
            <Typography fontWeight="600" color="success.main">{data.percentageContribution.toFixed(2)}%</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

const TopAnalyticsCard = ({ analytics }) => {
  const theme = useTheme();

  if (!analytics) {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                 <Card sx={{ p: 2, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 3, boxShadow: 3 }}>
                    <Typography>No analytics data for this month.</Typography>
                </Card>
            </Grid>
            <Grid item xs={12} md={6}>
                 <Card sx={{ p: 2, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography>No analytics data for this month.</Typography>
                </Card>
            </Grid>
        </Grid>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <AnalyticsItem
          title="Top Service"
          icon={<MiscellaneousServicesIcon color="primary" />}
          data={analytics.service}
          totalMonthlyAmount={analytics.service ? analytics.service.totalMonthlyServiceAmount : 0}
          theme={theme}
          type="service"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <AnalyticsItem
          title="Top Product"
          icon={<ShoppingBagOutlinedIcon color="secondary" />}
          data={analytics.product}
          totalMonthlyAmount={analytics.product ? analytics.product.totalMonthlyProductAmount : 0}
          theme={theme}
          type="product"
        />
      </Grid>
    </Grid>
  );
};

export default TopAnalyticsCard;